import type * as menuButtonModule from './CopilotChatDrawerMenuButton';
import type { CopilotChatDrawerMenuButtonProps } from './CopilotChatDrawerMenuButton.Props';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof menuButtonModule> = new LazyModule(
    () =>
        import(
            /* webpackChunkName: "CopilotChatDrawerMenuButton" */ './CopilotChatDrawerMenuButton'
        ),
    { name: 'CopilotChatDrawerMenuButton' }
);

export const LazyCopilotChatDrawerMenuButton: LazyComponent<
    CopilotChatDrawerMenuButtonProps,
    undefined
> = createLazyComponent(lazyModule, module => module.CopilotChatDrawerMenuButton);
